import { Link } from 'react-router-dom';

export function NotFound(): JSX.Element {
  return (
    <section className="mx-auto max-w-5xl px-4 py-8">
      <h1 className="mb-2 text-3xl font-bold text-gray-900 dark:text-gray-100">404 — Not found</h1>
      <p className="mb-6 text-gray-600 dark:text-gray-400">
        The page you tried to reach does not exist.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
      >
        ← Back to home
      </Link>
    </section>
  );
}
